<ion-item>
  <ion-label>Filter</ion-label>
  <ion-input type='text' placeholder="{{'SEARCH_BY_TITLE' | translate}}" (keyup)='updateFilter($event)'></ion-input>
</ion-item>